module.exports = __webpack_public_path__ + "bin/b0ed03179c2d9dd42de81b31f1ac0994.jpg";